var config = {};

config.web = {};
config.web.server_base = 'api.globeadmin.cltdev.com';
config.web.server_protocol = 'https';

module.exports = config;
